// extracted by mini-css-extract-plugin
export default {"dottedBorderLeft":"sYyWOBs7DxfIdU_ztAqL"};